/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreporttypeevent3Inputs */

const en_contentreporttypeevent3 = /** @type {(inputs: Contentreporttypeevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const de_contentreporttypeevent3 = /** @type {(inputs: Contentreporttypeevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Contentreporttypeevent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreporttypeevent3 = /** @type {((inputs?: Contentreporttypeevent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreporttypeevent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreporttypeevent3(inputs)
	return de_contentreporttypeevent3(inputs)
});
export { contentreporttypeevent3 as "contentReportTypeEvent" }